import React, { useEffect, useState, useRef, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/pdf.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import URI from 'urijs';

interface IProps {
  children: ReactNode,
}
interface IState {}

const PDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { children } = props;
  const uri = new URI(window.location.href);
  const res: any = uri.query(true);
  const result = res?.data ? decodeURIComponent(res?.data) : '{}';
  const path = JSON.parse(result) ;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="pdf-page-100" style={{
      marginTop: path?.type === 'export'  ? 0 : '20px',
    }}>
      {children}
    </section>
  );
};

export default observer(PDF);
